import { render, staticRenderFns } from "./AssignSupplierConfirmationModal.vue?vue&type=template&id=6cc1a3d3&"
import script from "./AssignSupplierConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AssignSupplierConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports